module.exports = __webpack_public_path__ + "img/no_moderator.4bebde89.webp";